module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<select name="' +
((__t = ( name )) == null ? '' : __t) +
'">\n    ';
 choices.map(function(choice) { ;
__p += '\n    <option value="' +
((__t = ( choice[0] )) == null ? '' : __t) +
'"';
 if (value === choice[0]) { ;
__p += ' selected';
 } ;
__p += '>' +
((__t = ( choice[1] )) == null ? '' : __t) +
'</option>\n    ';
 }) ;
__p += '\n</select>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./~/ejs-loader!./~/icarus-forms/module/js/templates/controls/select.ejs
// module id = 206
// module chunks = 2 3